import { css, StyleSheet } from 'aphrodite'
import React from 'react'
import { useTranslation } from 'react-i18next'
import proEco3 from '../../assets/Echangez.jpg'
import proEco4 from '../../assets/Economisez.jpg'
import proEco2 from '../../assets/Rassurez.jpg'
import proEco1 from '../../assets/Reposez.jpg'

import LayoutCol from '../../components/Layout/LayoutCol'
import { COLOR_WHITE } from '../../lib/colors'

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    width: '100%',
    position: 'relative',
    backgroundColor: '#E2D0D5',
    alignItems: 'flex-start',
    paddingBottom: '50px',
    '@media (max-width: 480px)': {
      flexDirection: 'column',
      paddingBottom: '0px',
    },
  },
  backgroundImage: {
    width: '100%',
    objectFit: 'cover',
  },
  contentContainer: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    zIndex: 2,
    display: 'flex',
    padding: '0px 10em',
    gap: '5em',
  },
  panel: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    color: COLOR_WHITE,
    justifyContent: 'center',
  },
  navbar: {
    position: 'absolute',
    zIndex: 10,
  },
  pictoMaker: {
    width: '9em',
  },
  pictoViewer: {
    width: '7.8em',
  },
  typo: {
    width: '30em',
  },
  title: {
    width: '50%',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '70px',
    lineHeight: '48px',
    display: 'flex',
    alignItems: 'center',
    letterSpacing: '-0.03em',
    color: '#718096',
    fontFamily: 'Helvetica Neue LT W05_75 Bd Ou',
    margin: 'auto',
    marginBottom: '5%',
    minHeight: '150px',
    whiteSpace: 'nowrap',
    '@media (max-width: 1024px)': {
      fontSize: '50px',
    },
    '@media (max-width: 480px)': {
      fontWeight: '700',
      fontSize: '55px',
      alignItems: 'flex-start',
      marginLeft: '7.5%',
      minHeight: '1px',
      marginTop: '20px',
    },
    '@media (max-width: 400px)': {
      fontSize: '45px',
    },
  },
  proDescFast: {
    width: '50%',
    fontStyle: 'normal',
    fontSize: '30px',
    fontWeight: 700,
    lineHeight: '30px',
    letterSpacing: '-0.03em',
    color: '#000000',
    margin: 'auto',
    marginTop: '10%',
    marginBottom: '10%',
    '@media (max-width: 480px)': {
      width: '85%',
    },
  },
  proDesc: {
    width: '50%',
    fontStyle: 'normal',
    fontSize: '25px',
    fontWeight: 700,
    lineHeight: '30px',
    letterSpacing: '-0.03em',
    color: '#000000',
    margin: '0 auto 25px',
    '@media (max-width: 480px)': {
      width: '85%',
    },
  },
  sectionImg: {
    display: 'block',
    width: '50%',
    objectFit: 'cover',
    margin: '0 auto',
    '@media (max-width: 480px)': {
      width: '85%',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    '@media (max-width: 480px)': {
      paddingBottom: '25px',
    },
  },
  descContainer: {
    '@media (min-width: 480px)': {
      minHeight: '275px',
    },
  },
})
function ProAdv() {
  const { t } = useTranslation('Part')
  return (
    <>
      <div className={css(styles.container)}>
        <LayoutCol col={12} xs={6}>
          <div className={css(styles.content)}>
            <p className={css(styles.title)}>
              {t('Calm')}
              <br />
              {t('You')}
            </p>
            <div className={css(styles.descContainer)}>
              <p className={css(styles.proDesc)}>{t('ecolo')}</p>
              <p className={css(styles.proDesc)}>{t('ecolo2')}</p>
            </div>
            <img
              src={proEco1}
              className={css(styles.sectionImg)}
              alt="Eco1"
              width="50%"
              height="auto"
            />
          </div>
        </LayoutCol>
        <LayoutCol col={12} xs={6}>
          <div className={css(styles.content)}>
            <p className={css(styles.title)}>
              {t('reassure')}
              <br />
              {t('You')}
            </p>
            <div className={css(styles.descContainer)}>
              <p className={css(styles.proDesc)}>{t('economic')}</p>
              <p className={css(styles.proDesc)}>{t('economicTwo')}</p>
            </div>
            <img
              src={proEco2}
              className={css(styles.sectionImg)}
              alt="Eco2"
              width="50%"
              height="auto"
            />
          </div>
        </LayoutCol>
      </div>
      <div className={css(styles.container)}>
        <LayoutCol col={12} xs={6}>
          <div className={css(styles.content)}>
            <p className={css(styles.title)}>
              {' '}
              {t('Trade')}
              <br />
              {t('Live')}
            </p>
            <div className={css(styles.descContainer)}>
              <p className={css(styles.proDesc)}>{t('usefulOne')}</p>
            </div>
            <img
              src={proEco3}
              className={css(styles.sectionImg)}
              alt="Eco3"
              width="50%"
              height="auto"
            />
          </div>
        </LayoutCol>
        <LayoutCol col={12} xs={6}>
          <div className={css(styles.content)}>
            <p className={css(styles.title)}>{t('Economic')}</p>
            <div className={css(styles.descContainer)}>
              <p className={css(styles.proDesc)}>{t('fastTwo')}</p>
            </div>
            <img
              src={proEco4}
              className={css(styles.sectionImg)}
              alt="Eco4"
              width="50%"
              height="auto"
            />
          </div>
        </LayoutCol>
      </div>
    </>
  )
}

export default ProAdv
